module.exports = __webpack_public_path__ + "img/bmac-logo.3469a206.png";